import { render, staticRenderFns } from "./PropostaAssinantePapel.vue?vue&type=template&id=55405043"
import script from "./PropostaAssinantePapel.vue?vue&type=script&lang=js"
export * from "./PropostaAssinantePapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports